"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TooltipBubble = _interopRequireDefault(require("../elements/TooltipBubble"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Tooltip extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
      isLoading: true,
      text: 'Loading ...'
    };
  }
  componentDidMount() {
    const {
      fieldName,
      text,
      getHelpQtip
    } = this.props;
    if (text) {
      this.setState({
        text,
        isLoading: false
      });
      return;
    }
    getHelpQtip(fieldName).then(data => {
      if (data && data.length > 0) {
        this.setState({
          text: data[0].textShort,
          isDisabled: false,
          isLoading: false
        });
      } else {
        this.setState({
          isDisabled: true,
          isLoading: false
        });
      }
    });
  }
  render() {
    const {
      text,
      isDisabled
    } = this.state;
    const {
      position,
      title,
      size,
      className,
      isBig,
      tipPosition
    } = this.props;
    if (isDisabled) return null;
    return /*#__PURE__*/_react.default.createElement(_TooltipBubble.default, {
      position: position,
      title: title,
      size: size,
      className: className,
      isBig: isBig,
      tipPosition: tipPosition,
      text: text
    });
  }
}
exports.default = Tooltip;
Tooltip.propTypes = {
  position: _propTypes.default.string,
  title: _propTypes.default.string,
  size: _propTypes.default.string,
  fieldName: _propTypes.default.string,
  className: _propTypes.default.string,
  text: _propTypes.default.string,
  isBig: _propTypes.default.bool,
  tipPosition: _propTypes.default.string,
  getHelpQtip: _propTypes.default.func
};
Tooltip.defaultProps = {
  position: 'top',
  title: '',
  size: '5',
  fieldName: '',
  className: '',
  isBig: false,
  tipPosition: undefined
};
//# sourceMappingURL=Tooltip.js.map